import React from 'react';
import './MarketplaceTab.scss';

const MarketplaceTab = ({selectedTab, onTabSelect, tabItems}) => {
  return (
    <div className="home-tabs-wrapper marketplace-tab">
      <section className="tabs-rail">
        {tabItems.map(tabItem => (
          <span
            key={tabItem.id}
            className={selectedTab.id === tabItem.id ? "tab-item selected-tab" : "tab-item"}
            onClick={() => onTabSelect(tabItem)}
          >
          {tabItem.name}
        </span>
        ))}

        {/*indicator*/}
        <span className={selectedTab.id === tabItems[1].id ? "indicator" : "indicator transformed"}/>
      </section>
    </div>
  );
};

export default MarketplaceTab;
